/*
  Chicks UI: comportamiento de cabecera, pie, home, catálogo y ficha.
  - [data-ck-agregar]  agrega la variante a la bolsa por AJAX y refresca el
                       contador con la sección `cart-icon-bubble` (la misma que
                       usa Dawn, así hay una sola fuente de marcado).
  - [data-ck-fav]      guarda o quita el producto de «guardados» en este
                       navegador (no hay app de wishlist todavía).
  - [data-ck-desliza]  flechas de los carriles.
  - [data-ck-linea]    tarjeta de línea de comestibles: el + abre la hoja de
                       sabor y presentación con los datos de la propia tarjeta.
  - [data-ck-menu]     abre y cierra el menú móvil.
  - --ck-cab           alto real de la cabecera, para lo que se pega debajo.
  Catálogo:
  - [data-ck-filtros]  cada cambio se aplica al momento: pide la sección con la
                       Section Rendering API y cambia las piezas [data-ck-parte].
                       Los desplegables se cierran entre sí, con Escape y al
                       tocar fuera; en teléfono van en una hoja.
  - [data-ck-mas-productos]  trae la página siguiente y la agrega a la rejilla.
  Ficha:
  - [data-ck-opcion]   al cambiar de opción pide la sección con `option_values`.
  - galería, cantidad, foto en grande y barra de compra fija en teléfono.
  - [data-ck-recomienda]  trae las recomendaciones de Shopify.
  Si un pedido falla se navega a la URL: nada depende de que el JS funcione.
*/
(() => {
  if (window.chicksUI) return;
  window.chicksUI = true;

  const revelaImagen = (t) => {
    if (!t.isConnected) return;
    const contenido = t.content.cloneNode(true);
    if (t.hasAttribute('data-ck-foto-alterna')) contenido.querySelectorAll('img').forEach((img) => {
      img.loading = 'eager';
      const listo = () => { img.dataset.ckFotoLista = ''; };
      img.addEventListener('load', listo, { once: true });
      img.addEventListener('error', () => img.remove(), { once: true });
      if (img.complete && img.naturalWidth) listo();
    });
    t.replaceWith(contenido);
  };
  const imagenesPendientes = 'IntersectionObserver' in window ? new IntersectionObserver((entradas) => {
    entradas.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      const t = target.querySelector('template[data-ck-imagen-diferida]');
      if (t) revelaImagen(t);
      imagenesPendientes.unobserve(target);
    });
  }, { rootMargin: '320px 0px' }) : null;
  function vigilaImagenes(scope = document) {
    scope.querySelectorAll('template[data-ck-imagen-diferida]').forEach((t) => {
      if (imagenesPendientes) imagenesPendientes.observe(t.parentElement); else revelaImagen(t);
    });
  }
  vigilaImagenes();
  document.addEventListener('shopify:section:load', (e) => vigilaImagenes(e.target));
  document.addEventListener('pointerover', (e) => {
    if (e.pointerType !== 'mouse') return;
    const t = e.target.closest('.ck-tarjeta')?.querySelector('template[data-ck-foto-alterna]');
    if (t) revelaImagen(t);
  }, { passive: true });

  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const CLAVE_FAV = 'chicks:guardados:v1';
  const telefono = matchMedia('(max-width: 900px)');
  let reloj;

  function aviso(texto, error) {
    let el = document.querySelector('.ck-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ck ck-aviso';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<span class="ck-ms" aria-hidden="true">check</span><span></span>';
      document.body.append(el);
    }
    el.firstElementChild.textContent = error ? 'close' : 'check';
    el.lastElementChild.textContent = texto;
    requestAnimationFrame(() => el.classList.add('ck-ver'));
    clearTimeout(reloj);
    reloj = setTimeout(() => el.classList.remove('ck-ver'), 2800);
  }

  function pintarBolsa(html) {
    const burbuja = document.getElementById('cart-icon-bubble');
    if (!html || !burbuja) return;
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (nuevo) burbuja.innerHTML = nuevo.innerHTML;
    burbuja.querySelector('.ck-cuenta')?.classList.add('ck-brinca');
  }

  // `datos` es el formulario de la ficha; sin él, el + de la tarjeta agrega una pieza.
  async function agregar(boton, datos) {
    if (boton.dataset.ckOcupado) return;
    boton.dataset.ckOcupado = '1';
    boton.setAttribute('aria-busy', 'true');
    const icono = boton.querySelector('.ck-ms');
    const antes = icono && icono.textContent;
    try {
      if (!datos) {
        datos = new FormData();
        datos.append('id', boton.dataset.ckAgregar);
        datos.append('quantity', '1');
      }
      const conCajon = !!document.getElementById('ck-bolsa');
      datos.append('sections', conCajon ? 'cart-icon-bubble,chicks-carrito' : 'cart-icon-bubble');
      const r = await fetch(`${raiz}cart/add`, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: datos,
      });
      const res = await r.json();
      if (!r.ok || res.status) {
        // Con poco inventario Shopify agrega menos de lo pedido y responde 422: la bolsa sí cambió.
        const secciones = conCajon ? 'cart-icon-bubble,chicks-carrito' : 'cart-icon-bubble';
        fetch(`${raiz}?sections=${secciones}`).then((b) => b.json()).then((s) => {
          pintarBolsa(s['cart-icon-bubble']);
          if (conCajon) pintarBolsaCajon(s['chicks-carrito']);
        }).catch(() => {});
        throw new Error(res.description || res.message || 'No se pudo agregar a la bolsa.');
      }
      pintarBolsa(res.sections && res.sections['cart-icon-bubble']);
      boton.classList.add('ck-listo');
      if (icono) icono.textContent = 'check';
      if (conCajon) {
        pintarBolsaCajon(res.sections && res.sections['chicks-carrito']);
        bolsa(true);
      } else {
        // Sin cajón (la propia página de la bolsa) el aviso es la única señal.
        aviso(`Agregado a tu bolsa: ${boton.dataset.ckNombre}`);
      }
      setTimeout(() => {
        boton.classList.remove('ck-listo');
        if (icono) icono.textContent = antes;
      }, 1400);
    } catch (e) {
      aviso(e.message, true);
    } finally {
      delete boton.dataset.ckOcupado;
      boton.removeAttribute('aria-busy');
    }
  }

  function leerFavs() {
    try { return JSON.parse(localStorage.getItem(CLAVE_FAV)) || []; } catch (e) { return []; }
  }

  function pintarFavs() {
    const favs = leerFavs();
    document.querySelectorAll('[data-ck-fav]').forEach((b) => {
      b.setAttribute('aria-pressed', String(favs.includes(b.dataset.ckFav)));
    });
  }

  function alternarFav(boton) {
    const favs = leerFavs();
    const i = favs.indexOf(boton.dataset.ckFav);
    if (i === -1) favs.push(boton.dataset.ckFav); else favs.splice(i, 1);
    try { localStorage.setItem(CLAVE_FAV, JSON.stringify(favs)); } catch (e) { /* sin almacenamiento: sólo visual */ }
    boton.setAttribute('aria-pressed', String(i === -1));
  }

  // Cambia cada [data-ck-parte] de `caja` por su igual en `html`, y deja como
  // estaban el foco, los desplegables abiertos, los scrolls y lo escrito.
  function refrescar(caja, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const activo = document.activeElement;
    const foco = activo && caja.contains(activo) ? activo.id : '';
    const abiertos = [...caja.querySelectorAll('details[open][id]')].map((d) => d.id);
    const scrolls = [...caja.querySelectorAll('[data-ck-scroll][id]')].map((el) => [el.id, el.scrollTop]);
    const valores = [...caja.querySelectorAll('[data-ck-conserva][id]')].map((el) => [el.id, el.value]);
    caja.querySelectorAll('[data-ck-parte]').forEach((el) => {
      const nuevo = doc.querySelector(`[data-ck-parte="${el.dataset.ckParte}"]`);
      if (nuevo) el.replaceWith(nuevo);
    });
    abiertos.forEach((id) => { const d = document.getElementById(id); if (d) d.open = true; });
    scrolls.forEach(([id, y]) => { const el = document.getElementById(id); if (el) el.scrollTop = y; });
    valores.forEach(([id, v]) => {
      const el = document.getElementById(id);
      if (el && v) { el.value = v; el.dispatchEvent(new Event('input', { bubbles: true })); }
    });
    if (foco) document.getElementById(foco)?.focus({ preventScroll: true });
    pintarFavs();
  }

  // ── Catálogo ─────────────────────────────────────
  let pedidoFiltros;

  function urlDeFiltros(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
    const q = params.toString();
    return form.action.split('?')[0] + (q ? `?${q}` : '');
  }

  // Si ya bajaste, la rejilla vuelve a quedar justo debajo de la barra.
  function alinearRejilla(catalogo) {
    const barra = catalogo.querySelector('.ck-filtros');
    const rejilla = catalogo.querySelector('.ck-catalogo__rejilla');
    if (!barra || !rejilla) return;
    const tope = barra.getBoundingClientRect().bottom + 16;
    const y = rejilla.getBoundingClientRect().top;
    if (y < tope) scrollTo({ top: scrollY + y - tope, behavior: 'smooth' });
  }

  async function filtrar(catalogo, url) {
    const destino = new URL(url, location.href);
    const pedir = new URL(destino);
    pedir.searchParams.set('section_id', catalogo.dataset.ckCatalogo);
    if (pedidoFiltros) pedidoFiltros.abort();
    const ctrl = (pedidoFiltros = new AbortController());
    catalogo.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(pedir, { signal: ctrl.signal });
      if (!r.ok) throw new Error(r.status);
      refrescar(catalogo, await r.text());
      history.replaceState(history.state, '', destino);
      const conteo = catalogo.querySelector('.ck-filtros__conteo');
      const anuncio = catalogo.querySelector('[data-ck-anuncio]');
      if (conteo && anuncio) anuncio.textContent = conteo.textContent.trim();
      catalogo.querySelector('[data-ck-hoja="abrir"]')?.setAttribute('aria-expanded', String(catalogo.hasAttribute('data-hoja')));
      if (!catalogo.hasAttribute('data-hoja')) alinearRejilla(catalogo);
    } catch (e) {
      if (e.name !== 'AbortError') location.href = destino;
    } finally {
      if (pedidoFiltros === ctrl) catalogo.removeAttribute('aria-busy');
    }
  }

  // En teléfono los filtros de la hoja se abren como acordeón y no se cierran entre sí.
  function cerrarDesplegables(catalogo, salvo) {
    catalogo.querySelectorAll('.ck-filtro[open]').forEach((d) => {
      if (d !== salvo && !(telefono.matches && d.closest('.ck-hoja'))) d.open = false;
    });
  }

  function hoja(catalogo, abrir) {
    if (abrir === catalogo.hasAttribute('data-hoja')) return;
    catalogo.toggleAttribute('data-hoja', abrir);
    document.documentElement.style.overflow = abrir ? 'hidden' : '';
    const boton = catalogo.querySelector('[data-ck-hoja="abrir"]');
    boton?.setAttribute('aria-expanded', String(abrir));
    if (abrir) {
      // Dos frames después: recién se vuelve visible (transform) y un solo rAF no basta para que
      // el navegador la considere enfocable todavía.
      requestAnimationFrame(() => requestAnimationFrame(() => catalogo.querySelector('.ck-hoja__cabeza button')?.focus()));
    } else {
      if (catalogo.contains(document.activeElement) && boton) boton.focus({ preventScroll: true });
      alinearRejilla(catalogo);
    }
  }

  async function masProductos(enlace) {
    const rejilla = document.getElementById(enlace.getAttribute('aria-controls'));
    const pie = enlace.closest('[data-ck-pie]');
    if (!rejilla || !pie || enlace.hasAttribute('aria-busy')) return;
    enlace.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(enlace.href);
      url.searchParams.set('section_id', enlace.dataset.ckMasProductos);
      const r = await fetch(url);
      if (!r.ok) throw new Error(r.status);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const nueva = doc.getElementById(rejilla.id);
      if (!nueva) throw new Error('sin rejilla');
      const nuevos = [...nueva.children];
      rejilla.append(...nuevos);
      const otroPie = doc.querySelector('[data-ck-pie]');
      if (otroPie) {
        otroPie.querySelector('[data-ck-anterior]')?.remove();
        pie.replaceWith(otroPie);
      } else {
        pie.remove();
      }
      pintarFavs();
      nuevos[0]?.querySelector('.ck-tarjeta__nombre a')?.focus({ preventScroll: true });
    } catch (e) {
      location.href = enlace.href;
    }
  }

  // ── Ficha ────────────────────────────────────────
  let pedidoVariante;
  const vigias = new WeakMap();

  // Sólo cuentan las fotos visibles: las de otros colores llevan `hidden`.
  const visibles = (raiz, sel) => [...raiz.querySelectorAll(sel)].filter((el) => !el.hidden);

  function irAFoto(ficha, mediaId, suave = true) {
    const pista = ficha.querySelector('[data-ck-pista]');
    if (!pista) return;
    const i = visibles(pista, ':scope > figure').findIndex((f) => f.dataset.ckMedia === String(mediaId));
    if (i >= 0) pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
  }

  function marcarFoto(ficha) {
    const pista = ficha.querySelector('[data-ck-pista]');
    if (!pista) return;
    const i = Math.round(pista.scrollLeft / pista.clientWidth);
    visibles(ficha, '.ck-galeria__mini').forEach((m, j) => m.setAttribute('aria-current', String(j === i)));
    // `toggleAttribute(name, true)` deja el valor en '' (cadena vacía), que
    // no es un token válido de aria-current (spec: page/step/location/date/
    // time/true/false): el CSS del punto activo lee sólo la presencia, así
    // que el estilo no se nota, pero un lector de pantalla sí puede leerlo
    // como inválido. Se pone/quita con el mismo valor que ya trae el marcado
    // inicial (`aria-current="true"`), y se quita del todo en vez de "false".
    visibles(ficha, '.ck-galeria__puntos i').forEach((p, j) => { if (j === i) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current'); });
  }

  // Al cambiar de color: sus fotos primero (la de la variante a la cabeza),
  // luego las comunes; las de otros colores se ocultan. Un color sin fotos
  // propias deja ver todas. Es el mismo orden que arma el Liquid al cargar.
  function filtrarGaleria(ficha, grupo, foto) {
    const pista = ficha.querySelector('[data-ck-pista]');
    if (!pista) return;
    const de = (el) => el.dataset.ckGrupo ?? '';
    const tiene = [...pista.children].some((f) => de(f).includes(grupo));
    [pista, ficha.querySelector('.ck-galeria__minis'), ficha.querySelector('.ck-galeria__puntos')].forEach((caja) => {
      if (!caja) return;
      const hijos = [...caja.children].filter((el) => !el.matches('.ck-galeria__sep'));
      hijos.forEach((el) => { el.hidden = tiene && de(el) !== '' && !de(el).includes(grupo); });
      const suyos = hijos.filter((el) => tiene && de(el).includes(grupo));
      const id = (el) => el.dataset.ckMedia ?? el.dataset.ckIr;
      suyos.sort((a, b) => (id(b) === foto) - (id(a) === foto));
      caja.prepend(...suyos);
    });
    pista.scrollTo({ left: 0 });
    marcarFoto(ficha);
  }

  function pintarBarra(ficha) {
    const barra = ficha.querySelector('.ck-barra-compra');
    if (!barra) return;
    const ver = ficha.dataset.ckPasado === 'true' && ficha.dataset.ckPie !== 'true';
    barra.classList.toggle('ck-ver', ver);
    barra.setAttribute('aria-hidden', String(!ver));
    barra.querySelector('button')?.setAttribute('tabindex', ver ? '0' : '-1');
  }

  // La barra fija sale cuando los botones de compra ya quedaron arriba. El
  // margen de abajo estira el área vigilada hasta el fondo: así «fuera» sólo
  // puede ser «arriba», y el aviso llega aunque se salte de golpe (ancla,
  // volver atrás). Un segundo vigía la esconde otra vez al llegar al pie,
  // para que no se lo tape. El bloque de compra se reemplaza al cambiar de
  // variante: se vuelve a vigilar.
  function vigilarCompra(ficha) {
    let vigia = vigias.get(ficha);
    if (!vigia) {
      const pie = document.querySelector('.ck-pie');
      vigia = {
        compra: new IntersectionObserver(([en]) => {
          ficha.dataset.ckPasado = String(!en.isIntersecting);
          pintarBarra(ficha);
        }, { rootMargin: '0px 0px 100000px 0px' }),
        pie: pie && new IntersectionObserver(([en]) => {
          ficha.dataset.ckPie = String(en.isIntersecting);
          pintarBarra(ficha);
        }),
      };
      if (vigia.pie) vigia.pie.observe(pie);
      vigias.set(ficha, vigia);
    }
    vigia.compra.disconnect();
    const compra = ficha.querySelector('[data-ck-parte="compra"]');
    if (compra) vigia.compra.observe(compra);
    pintarBarra(ficha);
  }

  async function cambiarVariante(input) {
    const ficha = input.closest('[data-ck-ficha]');
    if (!ficha) return;
    if (input.dataset.ckGrupo) filtrarGaleria(ficha, input.dataset.ckGrupo, input.dataset.ckFoto);
    else if (input.dataset.ckFoto) irAFoto(ficha, input.dataset.ckFoto);
    const ids = [...ficha.querySelectorAll('[data-ck-opcion]:checked')].map((i) => i.value).join(',');
    const base = ficha.dataset.ckUrl;
    if (pedidoVariante) pedidoVariante.abort();
    const ctrl = (pedidoVariante = new AbortController());
    try {
      const r = await fetch(`${base}?option_values=${ids}&section_id=${ficha.dataset.ckFicha}`, { signal: ctrl.signal });
      if (!r.ok) throw new Error(r.status);
      refrescar(ficha, await r.text());
      const id = ficha.querySelector('.ck-compra input[name="id"]')?.value;
      if (id) history.replaceState(history.state, '', `${base}?variant=${id}`);
      const foto = ficha.querySelector('[data-ck-foto-variante]')?.dataset.ckFotoVariante;
      if (foto && foto !== input.dataset.ckFoto) irAFoto(ficha, foto);
      vigilarCompra(ficha);
    } catch (e) {
      if (e.name !== 'AbortError') location.href = `${base}?option_values=${ids}`;
    }
  }

  function abrirLupa(ficha) {
    const pista = ficha.querySelector('[data-ck-pista]');
    const dialogo = ficha.querySelector('[data-ck-lupa-dialogo]');
    if (!pista || !dialogo || !dialogo.showModal) return;
    const figura = visibles(pista, ':scope > figure')[Math.round(pista.scrollLeft / pista.clientWidth)];
    if (!figura || !figura.dataset.ckGrande) return;
    dialogo.querySelector('[data-ck-lupa-img]').src = figura.dataset.ckGrande;
    dialogo.showModal();
  }

  function iniciarFicha(ficha) {
    if (ficha.dataset.ckListo) return;
    ficha.dataset.ckListo = '1';
    ficha.querySelector('[data-ck-pista]')?.addEventListener('scroll', () => marcarFoto(ficha), { passive: true });
    vigilarCompra(ficha);
  }

  async function recomendar(seccion) {
    if (seccion.dataset.ckListo) return;
    seccion.dataset.ckListo = '1';
    try {
      const r = await fetch(seccion.dataset.ckRecomienda);
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const tarjetas = doc.querySelector('.ck-vitrina__pista')?.children;
      if (!tarjetas || !tarjetas.length) return;
      seccion.querySelector('.ck-vitrina__pista').replaceChildren(...tarjetas);
      seccion.hidden = false;
      pintarFavs();
    } catch (e) { /* sin recomendaciones la sección se queda oculta */ }
  }

  // ── El cajón de la bolsa ──────────────────────
  // El panel hospeda la misma sección `chicks-carrito` que /cart, así que
  // − / + / Quitar los sigue atendiendo `chicks-ui-carrito.js` por
  // delegación. Aquí sólo se abre, se cierra y se repinta el cuerpo.
  // Las flechas de un carril sólo existen si hay algo fuera de la vista. Con
  // todas las categorías cabiendo, una flecha promete más de lo que hay.
  function flechas(pista) {
    const btns = [...document.querySelectorAll(`[data-ck-desliza][aria-controls="${pista.id}"]`)];
    if (!btns.length) return;
    const ver = () => {
      const sobra = pista.scrollWidth - pista.clientWidth > 4;
      btns.forEach((b) => {
        // Si el botón vive en una caja que sólo contiene flechas, se esconde
        // la caja: si no, queda su hueco (y su `gap`) en la rejilla.
        const caja = b.parentElement;
        const sola = caja && [...caja.children].every((h) => h.hasAttribute('data-ck-desliza'));
        (sola ? caja : b).hidden = !sobra;
      });
      // El carril reserva los lados para las flechas; sin ellas, se recupera.
      pista.closest('.ck-carril')?.classList.toggle('ck-carril--sin-flechas', !sobra);
    };
    ver();
    new ResizeObserver(ver).observe(pista);
    // Una foto que llega tarde cambia el ancho del carril: se vuelve a medir.
    pista.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', ver, { once: true });
    });
  }

  let bolsaUltimoFoco;
  function bolsa(abrir) {
    const cajon = document.getElementById('ck-bolsa');
    if (!cajon) return false;
    const abierto = abrir === undefined ? !cajon.hasAttribute('data-abierto') : abrir;
    cajon.toggleAttribute('data-abierto', abierto);
    cajon.inert = !abierto;
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
    if (abierto) {
      bolsaUltimoFoco = document.activeElement;
      (cajon.querySelector('#ck-carrito-titulo') || cajon.querySelector('.ck-bolsa__cerrar'))?.focus();
    } else if (bolsaUltimoFoco) {
      bolsaUltimoFoco.focus({ preventScroll: true });
      bolsaUltimoFoco = null;
    }
    return true;
  }

  function pintarBolsaCajon(html) {
    const cajon = document.getElementById('ck-bolsa');
    if (!cajon || !html) return;
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ck-cuerpo]');
    const viejo = cajon.querySelector('[data-ck-cuerpo]');
    if (!nuevo || !viejo) return;
    viejo.replaceWith(nuevo);
    // `chicks-ui-carrito.js` vuelve a enganchar lo que no es delegado
    // (el aviso de dónde se recoge, los vigías de la barra).
    document.dispatchEvent(new CustomEvent('ck:carrito'));
  }

  let cajonUltimoFoco;
  function menu(abrir) {
    const cajon = document.getElementById('ck-cajon');
    if (!cajon) return;
    const abierto = abrir === undefined ? !cajon.hasAttribute('data-abierto') : abrir;
    cajon.toggleAttribute('data-abierto', abierto);
    document.querySelectorAll('.ck-menu-btn').forEach((b) => b.setAttribute('aria-expanded', String(abierto)));
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
    if (abierto) {
      cajonUltimoFoco = document.activeElement;
      cajon.querySelector('.ck-cajon__panel a, .ck-cajon__panel button')?.focus();
    } else if (cajonUltimoFoco) {
      cajonUltimoFoco.focus({ preventScroll: true });
      cajonUltimoFoco = null;
    }
  }

  // ── Tarjeta de línea (comestibles) ───────────────
  // Los datos vienen en el JSON de la tarjeta (snippet chicks-tarjeta-linea):
  // una fila por variante. Aquí se agrupan en presentaciones (piezas, mg y
  // cannabinoide) y se pinta la hoja. Elegir no pide nada al servidor; el
  // botón Agregar es un [data-ck-agregar] normal.
  const dineroL = (c) => '$' + (c / 100).toLocaleString('es-MX', { maximumFractionDigits: 2 });
  const escL = (t) => String(t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));

  function lineaDatos(tarjeta) {
    if (tarjeta._ck) return tarjeta._ck;
    const filas = JSON.parse(tarjeta.querySelector('[data-ck-linea-datos]').textContent);
    const pres = [];
    filas.forEach((f) => {
      const clave = `${f.pz}|${f.mg}|${f.k}`;
      let p = pres.find((x) => x.clave === clave);
      if (!p) pres.push(p = { clave, pz: f.pz, mg: f.mg, k: f.k, filas: [] });
      p.filas.push(f);
    });
    const sabores = [];
    filas.forEach((f) => { if (f.s && !sabores.some((x) => x.s === f.s)) sabores.push({ s: f.s, c: f.c }); });
    const primera = filas.find((f) => f.a) || filas[0];
    tarjeta._ck = { pres, sabores, varias: new Set(pres.map((p) => p.k)).size > 1, sabor: primera.s, clave: `${primera.pz}|${primera.mg}|${primera.k}` };
    return tarjeta._ck;
  }

  function lineaPintar(tarjeta) {
    const d = lineaDatos(tarjeta);
    const pres = d.pres.find((p) => p.clave === d.clave);
    const fila = pres.filas.find((f) => f.s === d.sabor) || pres.filas[0];
    const nombre = tarjeta.querySelector('.ck-tarjeta__nombre a').textContent;
    const chips = d.sabores.length > 1 ? `<div class="ck-linea__sabores" role="group" aria-label="Sabor">${d.sabores.map((x) => {
      const hay = d.pres.some((p) => p.filas.some((f) => f.s === x.s && f.a));
      return `<button type="button" class="ck-linea__chip" data-ck-linea-sabor="${escL(x.s)}" aria-pressed="${x.s === d.sabor}" style="--ck-sabor:${escL(x.c || '')}"${hay ? '' : ' disabled'}><i aria-hidden="true"></i>${escL(x.s)}</button>`;
    }).join('')}</div>` : '';
    const filas = d.pres.map((p) => {
      const f = p.filas.find((x) => x.s === d.sabor && x.a) || p.filas.find((x) => x.a);
      const uno = p.filas.find((x) => x.s === d.sabor) || p.filas[0];
      const pz = p.pz ? `${p.pz} pz` : '';
      const mg = p.mg ? `${p.mg} mg` : '';
      const txt = [pz, mg].filter(Boolean).join(' · ') + (d.varias && p.k ? ` · ${escL(p.k)}` : '');
      const precio = (f || uno).p;
      return `<li><button type="button" class="ck-linea__fila" data-ck-linea-pres="${escL(p.clave)}" aria-pressed="${p.clave === d.clave}"${f ? '' : ' disabled'}>
        <span>${txt || escL(uno.n)}${f ? '' : ' · agotado'}</span>${p.pz > 1 ? `<small>${dineroL(Math.round(precio / p.pz / 100) * 100)}/pz</small>` : '<small></small>'}<b>${dineroL(precio)}</b></button></li>`;
    }).join('');
    const total = pres.pz > 1 && pres.mg ? `${pres.pz} × ${pres.mg} mg = ${(pres.pz * pres.mg).toLocaleString('es-MX')} mg` : '';
    const hoja = tarjeta.querySelector('[data-ck-linea-hoja]');
    hoja.innerHTML = `<div class="ck-linea__cabeza"><b>${d.sabores.length > 1 ? escL(fila.s) : 'Elige'}</b>
        <button type="button" class="ck-linea__cerrar" data-ck-linea-cerrar aria-label="Cerrar"><span class="ck-ms" aria-hidden="true">close</span></button></div>
      ${chips}<ul class="ck-linea__filas" role="list">${filas}</ul>
      <div class="ck-linea__compra"><p>${total}</p>
        <button type="button" class="ck-btn ck-btn--morado" data-ck-agregar="${fila.v}" data-ck-nombre="${escL(nombre)} ${escL(fila.s || '')}"${fila.a ? '' : ' disabled'}>${fila.a ? `Agregar · ${dineroL(fila.p)}` : 'Agotado'}</button></div>`;
    lineaReposo(tarjeta, fila);
  }

  // Lo que se ve sin abrir la hoja: punto marcado, nombre del sabor y la foto.
  function lineaReposo(tarjeta, fila) {
    tarjeta.querySelectorAll('.ck-linea__punto').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ckLineaSabor === fila.s)));
    const nombre = tarjeta.querySelector('[data-ck-linea-nombre-sabor]');
    if (nombre) nombre.textContent = fila.s || '';
    const foto = tarjeta.querySelector('.ck-tarjeta__media img');
    if (foto && fila.i && foto.getAttribute('src') !== fila.i) { foto.removeAttribute('srcset'); foto.src = fila.i; }
  }

  function lineaAbrir(tarjeta, abrir) {
    const hoja = tarjeta.querySelector('[data-ck-linea-hoja]');
    const boton = tarjeta.querySelector('.ck-mas[data-ck-linea-abrir]');
    if (abrir) lineaPintar(tarjeta);
    hoja.hidden = !abrir;
    if (boton) boton.setAttribute('aria-expanded', String(abrir));
    if (abrir) hoja.querySelector('[aria-pressed="true"]:not(:disabled), button:not(:disabled)')?.focus();
    else boton?.focus();
  }

  function lineaElegir(boton) {
    const tarjeta = boton.closest('[data-ck-linea]');
    const d = lineaDatos(tarjeta);
    if (boton.dataset.ckLineaSabor) {
      d.sabor = boton.dataset.ckLineaSabor;
      const actual = d.pres.find((p) => p.clave === d.clave);
      if (!actual.filas.some((f) => f.s === d.sabor && f.a)) {
        const otra = d.pres.find((p) => p.filas.some((f) => f.s === d.sabor && f.a));
        if (otra) d.clave = otra.clave;
      }
    } else {
      d.clave = boton.dataset.ckLineaPres;
      const p = d.pres.find((x) => x.clave === d.clave);
      if (!p.filas.some((f) => f.s === d.sabor && f.a)) d.sabor = (p.filas.find((f) => f.a) || p.filas[0]).s;
    }
    const sel = boton.dataset.ckLineaSabor ? `[data-ck-linea-sabor="${CSS.escape(d.sabor)}"]` : `[data-ck-linea-pres="${CSS.escape(d.clave)}"]`;
    const hoja = tarjeta.querySelector('[data-ck-linea-hoja]');
    lineaPintar(tarjeta);
    (hoja.hidden ? tarjeta : hoja).querySelector(sel)?.focus();
  }

  // ── Eventos ──────────────────────────────────────
  document.addEventListener('click', (e) => {
    const t = e.target;
    const mas = t.closest('[data-ck-agregar]');
    if (mas) { e.preventDefault(); agregar(mas); return; }

    const linea = t.closest('[data-ck-linea-abrir],[data-ck-linea-cerrar]');
    if (linea) { e.preventDefault(); lineaAbrir(linea.closest('[data-ck-linea]'), linea.hasAttribute('data-ck-linea-abrir')); return; }
    const lineaOp = t.closest('[data-ck-linea-sabor],[data-ck-linea-pres]');
    if (lineaOp) { lineaElegir(lineaOp); return; }

    const cerrarBolsa = t.closest('[data-ck-bolsa]');
    if (cerrarBolsa) { e.preventDefault(); bolsa(false); return; }

    const iconoBolsa = t.closest('#cart-icon-bubble');
    if (iconoBolsa && bolsa(true)) { e.preventDefault(); return; }

    const fav = t.closest('[data-ck-fav]');
    if (fav) { e.preventDefault(); alternarFav(fav); return; }

    const flecha = t.closest('[data-ck-desliza]');
    if (flecha) {
      const pista = document.getElementById(flecha.getAttribute('aria-controls'));
      if (pista) pista.scrollBy({ left: Number(flecha.dataset.ckDesliza) * pista.clientWidth * 0.7, behavior: 'smooth' });
      return;
    }

    const aplica = t.closest('[data-ck-aplica]');
    const catalogoAplica = aplica && aplica.closest('[data-ck-catalogo]');
    if (catalogoAplica) { e.preventDefault(); filtrar(catalogoAplica, aplica.href); return; }

    const botonHoja = t.closest('[data-ck-hoja]');
    if (botonHoja) {
      const catalogo = botonHoja.closest('[data-ck-catalogo]');
      hoja(catalogo, botonHoja.dataset.ckHoja === 'abrir');
      if (botonHoja.dataset.ckHoja !== 'abrir') cerrarDesplegables(catalogo);
      return;
    }
    if (!t.closest('.ck-filtro')) document.querySelectorAll('[data-ck-catalogo]').forEach((c) => cerrarDesplegables(c));

    const masProd = t.closest('[data-ck-mas-productos]');
    if (masProd) { e.preventDefault(); masProductos(masProd); return; }

    const paso = t.closest('[data-ck-cantidad]');
    if (paso) {
      const cantidad = paso.parentElement.querySelector('input');
      cantidad.value = Math.max(1, (Number(cantidad.value) || 1) + Number(paso.dataset.ckCantidad));
      return;
    }

    const ir = t.closest('[data-ck-ir]');
    if (ir) {
      const ficha = ir.closest('[data-ck-ficha]');
      if (ficha) irAFoto(ficha, ir.dataset.ckIr);
      return;
    }

    const lupa = t.closest('[data-ck-lupa]') || (!telefono.matches && t.closest('[data-ck-pista]'));
    if (lupa) { abrirLupa(lupa.closest('[data-ck-ficha]')); return; }
    const dialogo = t.closest('[data-ck-lupa-dialogo]');
    if (dialogo && (t === dialogo || t.closest('[data-ck-lupa-cerrar]'))) { dialogo.close(); return; }

    if (t.closest('[data-ck-menu]')) menu();
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.form && t.form.matches('[data-ck-filtros]')) {
      if (t.type === 'number' || t.type === 'search') return;
      const catalogo = t.form.closest('[data-ck-catalogo]');
      filtrar(catalogo, urlDeFiltros(t.form));
      if (t.name === 'sort_by') cerrarDesplegables(catalogo);
      return;
    }
    if (t.matches('[data-ck-opcion]')) cambiarVariante(t);
  });

  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-ck-buscar]')) return;
    const q = e.target.value.trim().toLowerCase();
    e.target.closest('.ck-filtro__panel').querySelectorAll('.ck-opcion').forEach((o) => {
      o.hidden = !!q && !o.textContent.toLowerCase().includes(q);
    });
  });

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-ck-filtros]')) {
      e.preventDefault();
      const catalogo = form.closest('[data-ck-catalogo]');
      const url = urlDeFiltros(form);
      if (new URL(url).href !== location.href) filtrar(catalogo, url);
      cerrarDesplegables(catalogo);
      hoja(catalogo, false);
      return;
    }
    if (form.matches('.ck-compra')) {
      // «Comprar ahora» sigue su camino normal: agrega y va al checkout.
      if (e.submitter && e.submitter.name === 'return_to') return;
      e.preventDefault();
      const boton = form.querySelector('button[name="add"]');
      if (boton) agregar(boton, new FormData(form));
    }
  });

  // Un desplegable abierto cierra a los demás. `toggle` no burbujea.
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (!d.open || !d.matches || !d.matches('.ck-filtro')) return;
    const catalogo = d.closest('[data-ck-catalogo]');
    if (catalogo) cerrarDesplegables(catalogo, d);
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      menu(false);
      bolsa(false);
      document.querySelectorAll('[data-ck-linea-hoja]:not([hidden])').forEach((h) => lineaAbrir(h.closest('[data-ck-linea]'), false));
      document.querySelectorAll('[data-ck-catalogo]').forEach((c) => { cerrarDesplegables(c); hoja(c, false); });
      return;
    }
    // Atrapa el foco dentro del cajón del menú o de la hoja de filtros, el que esté abierto.
    if (e.key !== 'Tab') return;
    const cajonAbierto = document.querySelector('#ck-bolsa[data-abierto] .ck-bolsa__panel')
      || document.querySelector('#ck-cajon[data-abierto] .ck-cajon__panel');
    const abierta = cajonAbierto || document.querySelector('[data-ck-catalogo][data-hoja] .ck-hoja');
    if (!abierta) return;
    const foco = [...abierta.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select,[tabindex]:not([tabindex="-1"])')]
      .filter((el) => el.offsetParent);
    if (!foco.length) return;
    const primero = foco[0];
    const ultimo = foco[foco.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    else if (!abierta.contains(document.activeElement)) { e.preventDefault(); primero.focus(); }
  });

  const cabecera = document.querySelector('.ck-cabecera-seccion');
  if (cabecera && 'ResizeObserver' in window) {
    new ResizeObserver(() => document.documentElement.style.setProperty('--ck-cab', `${cabecera.offsetHeight}px`)).observe(cabecera);
  }

  function iniciar() {
    pintarFavs();
    document.querySelectorAll('[data-ck-ficha]').forEach(iniciarFicha);
    document.querySelectorAll('[data-ck-recomienda]').forEach(recomendar);
    document.querySelectorAll('[data-ck-desliza][aria-controls]').forEach((b) => {
      const pista = document.getElementById(b.getAttribute('aria-controls'));
      if (pista && !pista.dataset.ckFlechas) { pista.dataset.ckFlechas = '1'; flechas(pista); }
    });
  }
  iniciar();
  document.addEventListener('shopify:section:load', iniciar);
  /* Fondo único: cada capa con patrón arranca en el origen de la PÁGINA, no en
     el suyo. Las secciones contiguas (piso de la calle, portada de gomitas,
     etc.) dibujan entonces la misma pared continua y no baldosas distintas. */
  function fasePatron() {
    const sx = window.scrollX, sy = window.scrollY;
    document.querySelectorAll('.ck-garabatos, body[data-ck-mundo="gomitas"] main, .ck-vitrina.ck-ancho--completo').forEach((el) => {
      const r = el.getBoundingClientRect();
      el.style.setProperty('--ck-ox', -Math.round(r.left + sx) + 'px');
      el.style.setProperty('--ck-oy', -Math.round(r.top + sy) + 'px');
      el.style.setProperty('--ck-fh', Math.round(Math.max(170, Math.min(210, r.width * .2))) + 'px');
    });
  }
  let faseCuadro = 0;
  function agendaFase() {
    if (faseCuadro) return;
    faseCuadro = requestAnimationFrame(() => { faseCuadro = 0; fasePatron(); if (window.__ckMapea) window.__ckMapea(); });
  }
  fasePatron();
  window.addEventListener('load', agendaFase);
  /* El fondo va primero y los textos de las bandas de título entran después (html.ck-fase):
     con el patrón ya en su lugar, un par de cuadros después del primer pintado. */
  {
    const fase = () => document.documentElement.classList.add('ck-fase');
    requestAnimationFrame(() => requestAnimationFrame(fase));
    setTimeout(fase, 1500);
  }
  window.addEventListener('resize', agendaFase);
  document.addEventListener('shopify:section:load', agendaFase);
  if ('ResizeObserver' in window) new ResizeObserver(agendaFase).observe(document.body);
  /* Los logos del patrón se encienden sólo bajo el puntero (o el toque).
     Se conserva la fase de cada baldosa y se excluye explícitamente el hero. */
  let capas = [];
  const movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)');
  const esHero = (el) => !!el.closest('.ck-liq__panel, .ck-hero__panel');
  function mapeaCapas() {
    capas = [];
    document.querySelectorAll('.ck-garabatos').forEach((el) => {
      if (esHero(el)) return;
      const c = getComputedStyle(el);
      const img = c.maskImage || c.webkitMaskImage || '';
      const oficial = /chicks-patron-trazo\.(svg|webp)/.test(img);
      const m = oficial ? 'a' : /fondo-suave-b\.webp/.test(img) ? 'b' : /fondo-suave-c\.webp/.test(img) ? 'c'
        : /fondo-suave\.webp/.test(img) ? 'a' : /franja-suave-b\.webp/.test(img) ? 'fb'
        : /franja-suave\.webp/.test(img) ? 'fa' : '';
      if (!m) return;
      el.dataset.ckMapa = m;
      if (oficial || m[0] === 'f') {
        el.style.setProperty('--ck-m-size', c.maskSize);
        el.style.setProperty('--ck-m-pos', el.closest('.ck-boletin__panel') ? '0px var(--ck-liq-desfase,0px)' : c.maskPosition);
        el.style.setProperty('--ck-m-rep', c.maskRepeat);
      } else el.style.setProperty('--ck-tam', c.maskSize.split(' ')[0]);
      capas.push({ el });
    });
    document.querySelectorAll('.ck-vitrina.ck-ancho--completo, body[data-ck-mundo="gomitas"] main').forEach((el) => {
      capas.push({ el });
    });
  }
  let prendeCuadro = 0, punto = null, apagar = 0;
  function prende() {
    prendeCuadro = 0;
    capas.forEach(({ el }) => {
      const r = el.getBoundingClientRect();
      const visible = r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth;
      const dentro = punto && visible && punto.x >= r.left && punto.x <= r.right && punto.y >= r.top && punto.y <= r.bottom;
      if (dentro) {
        el.style.setProperty('--ck-px', Math.round(punto.x - r.left) + 'px');
        el.style.setProperty('--ck-py', Math.round(punto.y - r.top) + 'px');
        el.dataset.prende = '1';
      } else delete el.dataset.prende;
    });
  }
  function agendaLuz() { if (!prendeCuadro) prendeCuadro = requestAnimationFrame(prende); }
  function apagaPuntero() { punto = null; agendaLuz(); }
  function apagaTodo() {
    clearTimeout(apagar);
    punto = null;
    capas.forEach(({ el }) => { delete el.dataset.prende; });
  }
  const mueve = (e) => {
    if (movimientoReducido.matches) return;
    punto = { x: e.clientX, y: e.clientY };
    clearTimeout(apagar);
    if (e.pointerType === 'touch') apagar = setTimeout(apagaPuntero, 900);
    agendaLuz();
  };
  document.addEventListener('pointermove', mueve, { passive: true });
  document.addEventListener('pointerdown', mueve, { passive: true });
  document.addEventListener('pointerleave', apagaPuntero);
  // Al desplazarse sólo se recoloca la luz bajo el puntero quieto; el scroll no prende nada.
  window.addEventListener('scroll', () => { if (punto) agendaLuz(); }, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) apagaTodo(); });
  movimientoReducido.addEventListener('change', apagaTodo);
  window.__ckMapea = mapeaCapas; // load, resize y cambios de alto, sin lecturas de estilo durante el scroll.
  mapeaCapas();
  /* Animaciones infinitas: sólo corren mientras la sección está a la vista.
     Fuera de pantalla se pausan (clase ck-fuera) y no gastan batería. */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => e.target.classList.toggle('ck-fuera', !e.isIntersecting));
    }, { rootMargin: '120px 0px' });
    document.querySelectorAll('.ck-mundos--vivo, .ck-tira, .ck-sello, .ck-liq__panel, .ck-calle, .ck-boletin__panel, .ck-catalogo__banda,.ck-blog__banda,.ck-nota__banda,.ck-tiendas__banda,.ck-contacto__banda,.ck-colec__banda,.ck-gom-franja,.ck-consejos').forEach((el) => io.observe(el));
  }
})();
